<template lang="pug">
  div.bank-packets.uploaded-packet-create
    e-modal(
    ref="modalForm"
    @confirm="sendForm()"
    @close="closeForm()"
    :hideDeleteButton="false"
    :title="fields.id ? fields.name : 'Загрузка'"
    :autoHeight="true"
    :showSavedBtn="!fields.id"
    saveBtnLabel="Загрузить"
    )
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              // файл для тест лежит в test/fixtures/5751041000_40703810647000000012_111_01_0608.zip
              e-form-group(
              name="bank_packet_file"
              inputType="simple-file-uploader"
              label="Файл"
              :model="fields"
              tabView="tab1"
              :required="true"
              uploadType="attachToForm"
              )

              e-form-group(
              name="billing_bank_id"
              inputType="select"
              label="Банк"
              :model="fields"
              :options="banks"
              tabView="tab1"
              :required="true"
              )

              e-form-group(
              name="billing_bank_packet_source_id"
              inputType="select"
              label="Источник"
              :model="fields"
              :options="sources"
              tabView="tab1"
              :required="true"
              optionTextKey="format"
              )


</template>

<script>
  import uploadPacketForm from './mixins/upload-packet-form'
  import {billing, bankPackets} from "../../api/api-endpoints"

  export default {
    mixins: [uploadPacketForm],
    methods: {
      closeForm () {
        this.$refs.modalForm.redirectToPrev()
      },
      getItemEndpoint (route) {
        return null
      },
      getBanksEndpoint () {
        return billing.banks({
          query: {
            'per-page': -1
          }
        })
      },
      getSourcesEndpoint () {
        return bankPackets.sources({
          query: {
            'per-page': -1
          }
        })
      },
      getUpdateOrCreateUrl () {
        return bankPackets.uploadedPacketCreate()
      }
    }
  }
</script>
